import { css } from '@emotion/react';

export const animationStyles = css`
  @keyframes slideInDown {
    from {
      transform: translate3d(0, -40px, 0);
      visibility: visible;
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
  @keyframes slideInRight {
    from {
      transform: translate3d(40px, 0, 0);
      visibility: visible;
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
  @keyframes slideInLeft {
    from {
      transform: translate3d(-40px, 0, 0);
      visibility: visible;
      opacity: 0;
    }

    to {
      transform: translate3d(0, 0, 0);
      opacity: 1;
    }
  }
  @keyframes showUpLeft {
    from {
      opacity: 0;
      width: 0;
    }

    to {
      opacity: 1;
      width: 50%;
    }
  }
  :root {
    --animate-duration: 1s;
    --animate-delay: 1s;
    --animate-repeat: 1;
  }
  .animated {
    animation-duration: var(--animate-duration);
    animation-fill-mode: both;
  }
  .animated.faster {
    animation-duration: calc(var(--animate-duration) / 2);
  }

  .animated.fast {
    animation-duration: calc(var(--animate-duration) * 0.8);
  }

  .animated.slow {
    animation-duration: calc(var(--animate-duration) * 2);
  }

  .animated.slower {
    animation-duration: calc(var(--animate-duration) * 3);
  }
  .slideInDown {
    animation-name: slideInDown;
  }
  .slideInLeft {
    animation-name: slideInLeft;
  }
  .slideInRight {
    animation-name: slideInRight;
  }
  .showUpLeft {
    animation-name: showUpLeft;
  }
  .animated.delay-01s {
    animation-delay: 0.1s;
  }
  .animated.delay-02s {
    animation-delay: 0.2s;
  }
  .animated.delay-03s {
    animation-delay: 0.3s;
  }
  .animated.delay-04s {
    animation-delay: 0.4s;
  }
  .animated.delay-05s {
    animation-delay: 0.5s;
  }
  .animated.delay-06s {
    animation-delay: 0.6s;
  }
  .animated.delay-07s {
    animation-delay: 0.7s;
  }
  .animated.delay-08s {
    animation-delay: 0.8s;
  }
  .animated.delay-09s {
    animation-delay: 0.9s;
  }
  .animated.delay-1-1s {
    animation-delay: 1.1s;
  }
  .animated.delay-1-2s {
    animation-delay: 1.2s;
  }
  .animated.delay-1-3s {
    animation-delay: 1.3s;
  }
  div[id^='__lpform_'] {
    display: none;
  }
  body {
    margin: 0;
  }
`;
